import React, { useEffect } from "react";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Generalcon from "./Generalcon";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Generalsurgery() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Generalcon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>General Surgery in Whitefield</title>
        <meta
          name="description"
          content="Are you looking for General Surgery in Whitefield? Then you are at the right place. We have the best general surgeon in Whitefield. Call us today."
        />
        <meta
          name="keywords"
          content="Best General Surgery in Whitefield, Best General Surgery in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestgeneralsurgeryinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestgeneralsurgeryinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers expert general surgery services including pre-operative evaluation, surgical consultations, wound management, minor and major procedures, post-operative care, and follow-up support by experienced surgeons.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "General surgical consultation and evaluation",
              "Pre-operative preparation",
              "Minor and major surgical procedures",
              "Wound care and suturing",
              "Post-operative care and monitoring",
              "Emergency surgical support",
              "Surgical patient education and follow-up",
            ],
            keywords: [
              "best general surgery in Immadihalli",
              "best general surgery in Whitefield",
              "best general surgery in Bangalore",
              "best general surgery in Kundalahalli",
              "best general surgery in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        General Surgery in Whitefield where our focus on excellence and
        personalized care sets us apart as a premier healthcare destination.
        Contact us today for the best general surgery in Whitefield.
      </h2>
      <Servicebanner name="General surgery" banner={"../photo/dd9.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Generalsurgery;
